import flattenDeep from "lodash/flattenDeep";
import get from "lodash/get";

// Get a flat array of citation objs without extra Contentful sys fields
export default function getCitationsFromRichText(node) {
  if (node == null) return null;
  const { data, content, nodeType } = node;

  // Traversing methods
  if (nodeType === "document") {
    return flattenDeep(content.map((n) => getCitationsFromRichText(n))).filter((n) => n);
  }
  if (
    nodeType === "paragraph" &&
    node.content.filter((c) => c.nodeType === "hyperlink" || (c.nodeType === "text" && c.value.length > 0)).length
  ) {
    return content.map((n) => getCitationsFromRichText(n)).filter((n) => n);
  }
  if (get(data, "target.sys.contentType.sys.id") === "howTo") {
    return get(node, `data.target.fields.steps['en-US']`, [])
      .map((step) => step.fields)
      .map((step) => getCitationsFromRichText(get(step, "content['en-US']")))
      .filter((n) => n);
  }

  // Citation Found
  if (nodeType === "embedded-entry-inline" && get(data, "target.sys.contentType.sys.id") === "citation") {
    return Object.keys(get(data, "target.fields")).reduce((cit, key) => {
      cit[key] = get(data, "target.fields")[key]["en-US"];
      return cit;
    }, {});
  }
}
